// extracted by mini-css-extract-plugin
module.exports = {"patrons":"Patrons_patrons__jqCZb","fade_in":"Patrons_fade_in__ExaNa"};